import type { DeviceInterface } from "./api.js";

/**
 * Which interfaces get a chart, and which are tucked away.
 *
 * Unnamed interfaces never chart (they have nothing to label one with), nor
 * do unmonitored ones; of the rest, hidden ones go behind a toggle rather
 * than disappearing, so hiding is never a way to lose track of a port.
 */
export function splitInterfaces(interfaces: readonly DeviceInterface[]): {
  shown: DeviceInterface[];
  hidden: DeviceInterface[];
} {
  const chartable = interfaces.filter((i) => i.monitored && i.if_name);
  return { shown: chartable.filter((i) => !i.hidden), hidden: chartable.filter((i) => i.hidden) };
}
